<template>
    <div
        v-intersect="{
            mode: mode,
            targetIntersectionRatio: targetIntersectionRatio,
            cooldownMilliSecond: cooldownMilliSecond
        }"
        @visible="e => $emit('visible', e)"
        @invisible="e => $emit('invisible', e)"
        @changeToVisible="e => $emit('changeToVisible', e)"
    >
        <slot></slot>
    </div>
</template>

<script>
import { intersectDirective as intersect } from '../intersectionObserver';

export default {
    directives: { intersect },
    props: {
        mode: { type: String, default: 'interval' },
        targetIntersectionRatio: { type: Number },
        cooldownMilliSecond: { type: Number }
    }
};
</script>
